import { request } from '../../services';

export async function getRoles() {
  return request.get(`/Catalogs/Api/v1/FixedCatalogs/Roles`).then((response) => {
    return response.data.map((element) => {
      return {
        id: element.key,
        name: element.value,
      };
    });
  });
}
